export default "__VITE_ASSET__BrXl4FoL__"